import React from "react";
import styles from "./styles.module.css";
import data from "./stages.json";
import Budu from "./icons/Budu.js";
import DHR from "./icons/DHR.js";
import Unicorn from "./icons/Unicorn.js";

const Career = () => {
  return (
    <>
      <div className={styles.root}>
        <h4 className={styles.title}>Карьерный хаб</h4>

        {data.map((item, i) => (
          <div key={i} className={styles.card}>
            <div className={styles.content}>
              <div className={styles.text}>
                <div className={styles.header}>
                  <div className={styles.headerText}>
                    <p className={styles.cardTitle}>{item.title}</p>

                    <div className={styles.mobileCardTitle}>
                      <div className={styles.stageNumber}>Этап {i + 1}</div>
                    </div>
                  </div>

                  <div className={styles.desktopDisplayNone}>
                    <div className={styles.stage}>
                      <img
                        className={styles.stageIcon}
                        src={item.icon}
                        alt={"Этап карьеры"}
                      />
                    </div>
                  </div>
                </div>

                <p className={styles.desc}>{item.desc}</p>
              </div>

              <div className={styles.iconsFlex}>
                <div className={styles.companyIcon}>
                  <a className={styles.link} href={item.link} target="_blank">
                    {i === 0 ? (
                      <Budu />
                    ) : i === 1 ? (
                      <div style={{ transform: "translateY(2px)" }}>
                        <Unicorn />
                      </div>
                    ) : i === 2 ? (
                      <DHR />
                    ) : null}
                  </a>

                  {i === 3 && (
                    <div className={styles.companies}>
                      <div className={styles.companyIcon}>
                        <a
                          className={styles.link}
                          href={item.link.split(" ")[0]}
                          target="_blank"
                        >
                          <Budu />
                        </a>
                      </div>

                      <div className={styles.companyIcon}>
                        <a
                          className={styles.link}
                          href={item.link.split(" ")[1]}
                          target="_blank"
                        >
                          <div style={{ transform: "translateY(2px)" }}>
                            <Unicorn />
                          </div>
                        </a>
                      </div>

                      <div className={styles.companyIcon}>
                        <a
                          className={styles.link}
                          href={item.link.split(" ")[2]}
                          target="_blank"
                        >
                          <DHR />
                        </a>
                      </div>
                    </div>
                  )}
                </div>
                <div className={styles.partnerSubtitle}>
                  {i === 3 ? " " : "Партнер"}
                </div>
              </div>
            </div>

            <div className={styles.stage}>
              <div
                className={[styles.stageNumber, styles.mobileDisplayNone].join(
                  " "
                )}
              >
                Этап {i + 1}
              </div>
              <div className={styles.mobileDisplayNone}>
                <img
                  className={styles.stageIcon}
                  src={item.icon}
                  alt={"Этап карьеры"}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Career;
